import { useState } from "react";
import { Panel, Label } from "@/components/SplitLayout";
import CopyButton from "@/components/CopyButton";

const toTitle = (s) =>
  s.replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
const toSentence = (s) =>
  s.toLowerCase().replace(/(^\s*\w|[.!?]\s*\w)/g, (c) => c.toUpperCase());
const words = (s) => s.trim().split(/\s+/).filter(Boolean);
const toCamel = (s) =>
  words(s)
    .map((w, i) =>
      i === 0 ? w.toLowerCase() : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
    )
    .join("");
const toPascal = (s) =>
  words(s)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join("");
const toSnake = (s) => words(s).join("_").toLowerCase();
const toKebab = (s) => words(s).join("-").toLowerCase();

const MODES = [
  { id: "upper", label: "UPPERCASE", fn: (s) => s.toUpperCase() },
  { id: "lower", label: "lowercase", fn: (s) => s.toLowerCase() },
  { id: "title", label: "Title Case", fn: toTitle },
  { id: "sentence", label: "Sentence case", fn: toSentence },
  { id: "camel", label: "camelCase", fn: toCamel },
  { id: "pascal", label: "PascalCase", fn: toPascal },
  { id: "snake", label: "snake_case", fn: toSnake },
  { id: "kebab", label: "kebab-case", fn: toKebab },
];

export default function CaseConverter() {
  const [text, setText] = useState("");
  const [mode, setMode] = useState("upper");

  const active = MODES.find((m) => m.id === mode);
  const output = text ? active.fn(text) : "";

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label>Input text</Label>
        <textarea
          data-testid="case-converter-input"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Type or paste text to convert..."
          className="h-40 w-full resize-none border border-border bg-card p-5 text-sm outline-none focus:ring-2 focus:ring-primary"
        />
      </div>

      <div className="space-y-2">
        <Label>Convert to</Label>
        <div className="flex flex-wrap gap-2">
          {MODES.map((m) => (
            <button
              key={m.id}
              data-testid={`case-${m.id}`}
              onClick={() => setMode(m.id)}
              className={`border px-4 py-2 font-mono text-xs transition-all duration-150 active:scale-[0.97] ${
                mode === m.id
                  ? "border-primary bg-primary text-primary-foreground"
                  : "border-border bg-card hover:border-primary hover:text-primary"
              }`}
            >
              {m.label}
            </button>
          ))}
        </div>
      </div>

      <Panel
        title="Result"
        testId="case-converter-output"
        action={<CopyButton text={output} />}
      >
        <pre className="min-h-[96px] whitespace-pre-wrap break-words font-mono text-sm leading-relaxed">
          {output || (
            <span className="text-muted-foreground">Converted text appears here…</span>
          )}
        </pre>
      </Panel>
    </div>
  );
}
